/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class BusinessProfileListModel extends JSONable {
  uuid: string | undefined = undefined;
  publicBusinessProfileUuid: string | undefined = undefined;
  validated: boolean | undefined = undefined;
  companyName: string | undefined = undefined;
  uniqueIdentificationNumber: string | undefined = undefined;
  vat: string | undefined = undefined;
  industryTypesValue: string | undefined = undefined;
  mainPhoneNumber: string | undefined = undefined;
  mainEmailAddress: string | undefined = undefined;
  country: string | undefined = undefined;
  ownerLegalEntityUuid: string | undefined = undefined;
  targetLegalEntityUuid: string | undefined = undefined;
  businessProfileType: string | undefined = undefined;
}
